import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.reset();
  }

  submit(event) {
    if ($(event.relatedTarget).val() == "turbo") {
      if (
        confirm(
          "Are you sure you want to use your credits as fast as possible?"
        )
      ) {
        $.rails.fire(this.element, "submit");
        // $(this)
        //   .parent("form")
        //   .submit();
        return false;
      }
    } else {
      // $(this)
      //   .parents("form")
      //   .submit();
      $.rails.fire(this.element, "submit");

      return false;
    }
  }
}
